import React from 'react'
import Hero from '../components/Hero'
import AboutPreview from '../components/AboutPreview'
import ServicesSection from '../components/ServicesSection'
import ProjectPreview from '../components/ProjectPreview'
import ClientsPartners from '../components/ClientsPartners'


function Home() {
  return (
    <div>
        <Hero/>
        <AboutPreview/>
        <ServicesSection/>
        <ProjectPreview/>
        <ClientsPartners/>    
    </div>
  )
}

export default Home